<template>
  <section id="pricePlans" class="deal-plans-features">
    <h3 class="pdp-section-header font-weight-bold">
      Plans &amp; features
    </h3>
    <DealPropertyList
      v-if="deal.default_plan_terms.length"
      id-prefix="deal-terms"
      title="Deal terms &amp; conditions"
      :properties="deal.default_plan_terms"
    >
      <template #afterPropertyList>
        <div v-if="callout" class="deal-plans-callout">
          <AwardBadge class="mr-2 deal-callout-badge" />
          <GuaranteeText
            :callout-type="callout"
            :refundable-days="deal.refundable_days"
            :is-freebie="deal.is_free"
            class="callout-text"
          />
        </div>
      </template>
    </DealPropertyList>
    <DealPropertyList
      v-if="deal.common_features.length"
      id-prefix="deal-features"
      class="mt-3"
      title="Features included in all plans"
      :properties="deal.common_features"
    />
  </section>
</template>

<script>
import AwardBadge from '~/static/award-badge.svg?inline';
import DealPropertyList from './DealPropertyList.vue';
import GuaranteeText from '../../pdp/GuaranteeText.vue';

export default {
  components: { AwardBadge, DealPropertyList, GuaranteeText },

  props: {
    deal: {
      type: Object,
      required: true,
    },
  },

  computed: {
    callout() {
      return this.deal.money_back_callout_type;
    },
  },
};
</script>

<style lang="scss" scoped>
  .deal-plans-features > *:not(:first-child) {
    margin-top: 24px;
  }

  .callout-text {
    margin-bottom: 0;
  }

  .deal-plans-callout {
    display: inline-flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px 16px;
    background: rgba(165, 196, 255, 0.5);
    border-radius: 4px;

    .deal-callout-badge {
      overflow: visible;
      width: 22px;
    }
  }
</style>
